/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse } from './FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse';
import {
    FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSON,
    FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSONTyped,
    FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSON,
    FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSONTyped,
} from './FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse';
import type { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
import {
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped,
} from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';

/**
 * 
 * @export
 * @interface FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse
 */
export interface FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse
     */
    Success: boolean;
    /**
     * 
     * @type {FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse
     */
    Data: FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponse;
    /**
     * 
     * @type {FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse
     */
    Error?: FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError | null;
}

/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse(value: object): value is FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('Data' in value) || value['Data'] === undefined) return false;
    return true;
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseFromJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse {
    return FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'Data': FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseToJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse {
    return FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponseToJSONTyped(value?: FxGamesLibWebRpcContractsFxGamesResponseOfCheckBuyProductsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'Data': FxIdApplicationStoreCheckBuyProductsCheckBuyProductsResponseToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}

